import { Routes } from '@angular/router';
import { LayoutComponent } from 'Admin/layout/layout.component'
import { OAuth2Service } from "@ngxsuit"

import { MENUITEM } from 'Admin/interfaces'

export const ROOTROUTES: Routes = [
    {
        path: '',
        loadChildren: 'Admin/layout/layout.module#LayoutModule',
        canActivate:[OAuth2Service]
    },
    { path: 'login', loadChildren: 'Admin/login/login.module#LoginModule' },
    { path: 'signup', loadChildren: 'Admin/signup/signup.module#SignupModule' },
    { path: 'not-found', loadChildren: 'Admin/not-found/not-found.module#NotFoundModule' },
    { path: '**', redirectTo: 'not-found' }
];


export const MENUS: MENUITEM[] = [
    {sort:1, name:"dashboard", link:"/dashboard", image:"/images/home.png", title:"Dashboard"},
    {sort:100, name:"store", link:"/store", image:"/images/home.png", title:"Store"},
    {sort:130, parent:'store', name:"store_general", link:"/store/general", title:"General"},
    {sort:160, parent:'store', name:"store_sale_rules", link:"/store/salerules", title:"Sale Rules"},
    {sort:190, parent:'store', name:"store_theme", link:"/store/theme", title:"Theme"},
    {sort:192, parent:'store', name:"store_payment", link:"/store/payment", title:"Payment"},
    {sort:195, parent:'store', name:"store_configuration", link:"/store/configuration", title:"Configuration"},
    {sort:200, name:"system", link:"/system", title:"System"},
];

// export const PROVIDERS = [AuthGuard]

//import { LayoutComponent } from 'RootLayout/layout/layout.component';
export const CHILDROUTES: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {
                path: "dashboard",
                loadChildren: "Admin/dashboard/dashboard.module#DashboardModule",
                canActivate: [OAuth2Service] 
            }
        ]
    },
    {
        path: 'stores/:store_id', component: LayoutComponent,
        children: [
            {
                path: "dashboard",
                loadChildren: "Admin/dashboard/dashboard.module#DashboardModule",
                canActivate: [OAuth2Service] 
            },
            { 
                path: "store/general",  
                loadChildren: "Admin/pages/store/general/general.module#GeneralModule",
                canActivate: [OAuth2Service] 
            },
            { 
                path: "store/payment",  
                loadChildren: "Admin/pages/store/payment/payment.module#PaymentModule",
                canActivate: [OAuth2Service]
            },
            { 
                path: "configuration/:name",  
                loadChildren: "Admin/pages/configuration/nav/configuration.nav.module#ConfigurationNavModule" ,
                canActivate: [OAuth2Service] 
            }
        ]
    }
];